export default "__VITE_ASSET__e2858023__"